<template>
    <button type="button" class="chat-image" :class="{ 'chat-image--failed': failed }" @click="$emit('open')">
        <img v-if="src" :src="src" alt="">
        <span v-else-if="failed" class="chat-image__failed">!</span>
    </button>
</template>

<script>
// Kafelek zdjęcia w dymku. Stały rozmiar od razu (brak skakania przewijania),
// a o pobranie prosi dopiero, gdy wjedzie w widoczny obszar listy.
export default {
    props: {
        src: { type: String, default: null },
        failed: { type: Boolean, default: false }
    },
    mounted() {
        if (this.src) return

        if (typeof IntersectionObserver === 'undefined') {
            this.$emit('visible')
            return
        }

        this.observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) {
                this.$emit('visible')
                this.disconnect()
            }
        }, { rootMargin: '200px' })
        this.observer.observe(this.$el)
    },
    beforeDestroy() {
        this.disconnect()
    },
    methods: {
        disconnect() {
            if (this.observer) {
                this.observer.disconnect()
                this.observer = null
            }
        }
    }
}
</script>

<style scoped>
.chat-image {
    width: 120px;
    height: 90px;
    padding: 0;
    border: none;
    border-radius: 8px;
    overflow: hidden;
    cursor: zoom-in;
    background: var(--chat-image-placeholder);
}

.chat-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.chat-image--failed {
    cursor: default;
}

.chat-image__failed {
    color: var(--chat-muted);
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/Tickets/ChatImage.vue